import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatAutocompleteTrigger, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { AddAddressComponent } from 'src/app/shared/add-address/add-address.component';
import { ShippingContactTypeNameEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { CustomerDetailsPopupComponent } from '../customer-details-popup/customer-details-popup.component';
import { LeadAccountDetailsPopupComponent } from '../lead-account-details-popup/lead-account-details-popup.component';
import { OrdersCustomAddressComponent } from '../orders-custom-address/orders-custom-address.component';
import { AddQuickContactComponentForm } from '../quick-contact/add-quick-contact-form.component';
import { MapDialogComponent } from './map-dialog/map-dialog.component';

declare const google: any;

@Component({
    selector: 'app-orders-shipping-form',
    templateUrl: './orders-shipping-form.component.html',
    styleUrls: ['./orders-shipping-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersShippingFormComponent implements OnInit {
    @ViewChild('matShipFromAutocomplete', { read: MatAutocompleteTrigger, static: false }) shipFromAutoComplete: MatAutocompleteTrigger;
    @ViewChild('matShipToAutocomplete', { read: MatAutocompleteTrigger, static: false }) shipToAutoComplete: MatAutocompleteTrigger;
    @ViewChild('matShipPayerAutocomplete', { read: MatAutocompleteTrigger, static: false }) shipPayerAutoComplete: MatAutocompleteTrigger;
    @ViewChild('matShipIntermediaryAutocomplete', { read: MatAutocompleteTrigger, static: false }) shipIntermediaryAutoComplete: MatAutocompleteTrigger;

    @ViewChild('QQCustomFromAddress', { static: false }) QQCustomFromAddress:
        OrdersCustomAddressComponent;
    @ViewChild('QQCustomToAddress', { static: false }) QQCustomToAddress:
        OrdersCustomAddressComponent;
    @ViewChild('QQCustomPayerAddress', { static: false }) QQCustomPayerAddress:
        OrdersCustomAddressComponent;
    @ViewChild('QQCustomIntermediaryAddress', { static: false }) QQCustomIntermediaryAddress:
        OrdersCustomAddressComponent;
    @ViewChild('shippingAddressForm', { static: true }) shippingAddressForm: NgForm;
    @Output() emitRevertUpdateAccountDetails: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitShippingInfoFrom: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitShippingInfoTo: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitFromDistance: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitUpdateAccountDetails: EventEmitter<any> = new EventEmitter<any>();
    @Input() isPanelExpended: boolean;
    @Input() isQuickQuote: boolean;
    @Input() isJobForm: boolean;
    @Input() readOnly: boolean;
    @Input() set accountDetailsParam(accountParam: any) {
        this.accountParamLocal = accountParam;
        if (accountParam.accountId) {
            if (!accountParam.isContactDeleted) {
                this.ordersFrom = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.ordersTo = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                if (accountParam.isAccountChanged) {
                    this.ordersPayer = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                }
                this.ordersIntermediary = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.ordersFrom.accountName = accountParam.accountName;
                this.ordersTo.accountName = accountParam.accountName;
                this.ordersPayer.accountName = accountParam.accountName;
                this.ordersIntermediary.accountName = accountParam.accountName;
                this.ordersFrom.addressIndicator = accountParam.addressIndicator;
            } else {
                this.isContactChanged = true;
            }
            this.accountId = accountParam.accountId;
            this.accountTypeId = accountParam.accountTypeId;
            this.selectedContactId = accountParam.contactId;
            this.onChangeFromAddress();
            this.onChangeToAddress();
            if (accountParam.isAccountChanged) {
                this.onChangePayerAddress();
            }
            this.onChangeIntermediaryAddress();
        }
    }

    @Input() set shipperConsigneeParams(params: any) {
        if (params) {
            this.shipper = params.shipper;
            this.consignee = params.consignee;
            this.payer = params.payer;
            if (this.payer) {
                this.ordersPayer = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.onChangePayerAddress();
            }
            this.intermediary = params.intermediary;
            this.setShippingInformation();
        }
    }

    @Input() set rfqData(rfqData: any) {
        if (rfqData) {
            this.rfqDetails = rfqData;
        }
    }
    @Input() isConvertToQuote: boolean;
    @Input() order_Id: any;

    shippingContactTypeNameEnum: typeof ShippingContactTypeNameEnum = ShippingContactTypeNameEnum;
    ordersDataModel = new CommonDataModel();
    ordersFrom = Object.assign({}, this.ordersDataModel.shippingAddressModel);
    ordersTo = Object.assign({}, this.ordersDataModel.shippingAddressModel);
    ordersPayer = Object.assign({}, this.ordersDataModel.shippingAddressModel);
    ordersIntermediary = Object.assign({}, this.ordersDataModel.shippingAddressModel);
    toCustomAddress = Object.assign({}, this.ordersDataModel.shippingCustomAddressModel);
    fromCustomAddress = Object.assign({}, this.ordersDataModel.shippingCustomAddressModel);
    accountDetails: any;
    tenantList: any[] = [];
    accountId: any;
    accountTypeId: any;
    accountAddressIndicator: any;
    addressFromList: any;
    addressToList: any;
    addressPayerList: any;
    addressIntermediaryList: any;
    pattern = new CustomPattern();
    isFromCustomAddress = false;
    isToCustomAddress = false;
    isPayerCustomAddress = false;
    isIntermediaryCustomAddress = false;
    shipper: any;
    consignee: any;
    payer: any;
    intermediary: any;
    isQuickQuoteForm = true;
    rfqDetails: any;
    initialLoadFrom = true;
    initialLoadPayer = true;
    getTGeocode: any = this.commonService.getTGeocode();
    getTZipcode: any = this.commonService.getTZipcode();
    getTFullAddress: any = this.commonService.getTFullAddress();
    tenantId = this.commonService.getTenentId();
    primaryContactId: any;
    isShipFromAddressLoading = false;
    isShipToAddressLoading = false;
    isPayerAddressLoading = false;
    isIntermediaryAddressLoading = false;
    isShipFromAddressViewLoading = false;
    isShipToAddressViewLoading = false;
    isPayerAddressViewLoading = false;
    isIntermediaryAddressViewLoading = false;
    selectedContactId = null;
    isContactChanged = false;
    fromModelChanged = new Subject<any>();
    toModelChanged = new Subject<any>();
    payerModelChanged = new Subject<any>();
    intermediaryModelChanged = new Subject<any>();
    shipToFranchiseDetails = {
        isSpanToFranchiseDetails: false,
        txtSpanToFranchiseDetails: '',
        franchise_general_email: ''
    };
    accountParamLocal: any;
    selectedContactAccountId: any = '';
    geocoder: any;
    desti: any;
    directions: any = {};
    isMapLoading = false;

    constructor(
        private dialog: MatDialog,
        private contactService: ContactService,
        private commonMethod: CommonMethod,
        private commonService: CommonService,
        private toastr: ToastrService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.fromModelChanged.pipe(debounceTime(500)).subscribe((data: any) => {
            this.onChangeFromAddress(data.searchText, data.addressRemove);
        });
        this.toModelChanged.pipe(debounceTime(500)).subscribe((data: any) => {
            this.onChangeToAddress(data.searchText);
        });
        this.payerModelChanged.pipe(debounceTime(500)).subscribe((data: any) => {
            this.onChangePayerAddress(data.searchText, data.addressRemove);
        });
        this.intermediaryModelChanged.pipe(debounceTime(500)).subscribe((data: any) => {
            this.onChangeIntermediaryAddress(data.searchText);
        });

        this.commonMethod.setAddressFromAccount.subscribe((data: any) => {
            const getPrimaryAddress = this.addressFromList.find(item => item.isPrimaryAddress && item.isPrimaryContact);
            if (getPrimaryAddress) {
                let shouldPrompt = true;
                let ordersArray = null;

                switch (data) {
                    case CommonConstants.appComponent.shipTo:
                        ordersArray = this.ordersTo;
                        break;
                    case CommonConstants.appComponent.shipFrom:
                        ordersArray = this.ordersFrom;
                        break;
                    case CommonConstants.appComponent.shipPayer:
                        ordersArray = this.ordersPayer;
                        break;
                    case CommonConstants.appComponent.shipIntermediary:
                        ordersArray = this.ordersIntermediary;
                        break;
                    default:
                        break;
                }

                shouldPrompt = ordersArray.accountId !== null && getPrimaryAddress.accountId !== ordersArray.accountId;
                shouldPrompt ? this.onConfirmReplacingAccount(data) : this.replaceData(data);

                if (data === CommonConstants.appComponent.shipTo) {
                    this.onIsConsigneeAddressChange('ordersToIsConsigneeAddress');
                } else if (data === CommonConstants.appComponent.shipIntermediary) {
                    this.onIsConsigneeAddressChange('ordersIntermediaryIsConsigneeAddress');
                }
            }
        });

        this.commonMethod.getPayerData.subscribe((data) => {
            if (data) {
                this.shippingAddressForm.form.markAsDirty();
                this.commonService.objectMapping(this.ordersPayer, data);
                this.ordersPayer.isQuickContact = data.isConvertToLead ? false : this.ordersPayer.isQuickContact;
                this.isPayerCustomAddress = this.ordersPayer.isQuickContact;
                this.ordersPayer.provinceName = data.province || '';
                this.ordersPayer.isChanged = true;
                this.ordersPayer.primaryExt = data.ext;
                this.ordersPayer.contactName =
                    (data.firstName ? data.firstName + ' ' : '') + (data.lastName ? data.lastName : '');
                this.ordersPayer.phoneNumber = data.phone;
                this.ordersIntermediary.isQuickContact ? this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer) : '';
                if (this.ordersFrom.contactId === this.ordersPayer.contactId) {
                    this.isFromCustomAddress = this.ordersPayer.isQuickContact;
                    this.commonService.objectMapping(this.ordersFrom, this.ordersPayer);
                }
                if (this.ordersTo.contactId === this.ordersPayer.contactId) {
                    this.isToCustomAddress = this.ordersPayer.isQuickContact;
                    this.commonService.objectMapping(this.ordersTo, this.ordersPayer);
                }
                if (this.ordersIntermediary.contactId === this.ordersPayer.contactId) {
                    this.isPayerCustomAddress = this.ordersPayer.isQuickContact;
                    this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer);
                }
            }
        })
    }

    ngOnInit() {
        if (this.activatedRoute.snapshot.queryParams.accountId) {
            this.isContactChanged = true;
        }
        window.addEventListener('scroll', this.autoCompleteScrollEvent, true);
        this.commonMethod.getTenantList.subscribe(franchiseList => {
            this.tenantList = franchiseList;
        });
    }

    onConfirmReplacingAccount(data: any) {
        this.commonService.getConfirmationPopup(
            `You want to Replace <b class="text-capitalize"> ${data} </b> address with Main Account's Primary Contact`,
            CommonConstants.appComponent.no,
            CommonConstants.appComponent.yes
        ).then(result => {
            if (result) {
                this.replaceData(data);
            }
        });
    }

    replaceData(data: any) {
        const getPrimaryAddress = this.addressFromList.find(item => item.isPrimaryAddress && item.isPrimaryContact);
        if (getPrimaryAddress) {
            switch (data) {
                case 'shipTo':
                    this.commonService.objectMapping(this.ordersTo, getPrimaryAddress);
                    break;
                case 'shipFrom':
                    this.commonService.objectMapping(this.ordersFrom, getPrimaryAddress);
                    break;
                case 'shipPayer':
                    this.commonService.objectMapping(this.ordersPayer, getPrimaryAddress);
                    break;
                case 'shipIntermediary':
                    this.commonService.objectMapping(this.ordersIntermediary, getPrimaryAddress);
                    break;
                default:
                    break;
            }
        }
        this.shippingAddressForm.form.markAsDirty();
    }

    onCheckPrimaryAddress(obj1: any, obj2: any): boolean {
        return obj1.accountId !== obj2.accountId ||
            obj1.contactId !== obj2.contactId ||
            obj1.contactName !== obj2.contactName;
    }

    calculateDistanceByAddress(origin, destination, address) {
        return new Promise((resolve, reject) => {
            const service = new google.maps.DistanceMatrixService();
            const originF = new Array(origin);
            const desti = new Array(destination);
            let distanceText = '';

            service.getDistanceMatrix({
                origins: originF,
                destinations: desti,
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.IMPERIAL
            }, (response: any, status) => {
                if (status === google.maps.DistanceMatrixStatus.OK) {
                    if (response.rows[0].elements[0].status === status) {
                        const apiDistanceText = response.rows[0].elements[0].distance.text.split(' ');
                        if (apiDistanceText[1] === 'ft') {
                            response.rows[0].elements[0].distance.text = `${parseFloat(apiDistanceText[0]) / 5280} mi`;
                        }
                        distanceText = response.rows[0].elements[0].distance.text;
                        address.distance = response.rows[0].elements[0].distance.text;
                    }
                    if (response.rows[0].elements[0].status === status) {
                        const apiDistanceText = response.rows[0].elements[0].distance.text.split(' ');
                        if (apiDistanceText[1] === 'ft') {
                            response.rows[0].elements[0].distance.text = `${parseFloat(apiDistanceText[0]) / 5280} mi`;
                        }
                        distanceText += ` ${response.rows[0].elements[0].duration.text}`;
                        address.distance += ` ${response.rows[0].elements[0].duration.text}`;
                    }
                    this.emitFromDistance.emit(address);
                    resolve(address.distance ? true : false);
                } else {
                    this.emitFromDistance.emit(address);
                    resolve(address.distance ? true : false);
                }
            }, (error) => {
                this.emitFromDistance.emit(address);
                return resolve(false);
            });
        });

    }


    calculateDistanceByZIP(origin, destination, address) {
        const service = new google.maps.DistanceMatrixService();
        const originF = new Array(origin);
        const desti = new Array(destination);

        service.getDistanceMatrix({
            origins: originF,
            destinations: desti,
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.IMPERIAL
        },
            (response: any, status) => {
                if (status === google.maps.DistanceMatrixStatus.OK) {
                    if (response.rows[0].elements[0].status === status) {
                        const apiDistanceText = response.rows[0].elements[0].distance.text.split(' ');
                        if (apiDistanceText[1] === 'ft') {
                            response.rows[0].elements[0].distance.text = `${parseFloat(apiDistanceText[0]) / 5280} mi`;
                        }
                        address.distance = response.rows[0].elements[0].distance.text;
                    }
                    if (response.rows[0].elements[0].status === status) {
                        const apiDistanceText = response.rows[0].elements[0].distance.text.split(' ');
                        if (apiDistanceText[1] === 'ft') {
                            response.rows[0].elements[0].distance.text = `${parseFloat(apiDistanceText[0]) / 5280} mi`;
                        }
                        address.distance += ` ${response.rows[0].elements[0].duration.text}`;
                    }
                    this.emitFromDistance.emit(address);
                } else {
                    this.emitFromDistance.emit(address);
                }
            });
    }

    calculateDistance(addressObj, address) {
        if (this.tenantId === 0) {
            const fId = parseInt(localStorage.getItem('oidcCNFFranchaiseId'));
            const matchedTenant = this.tenantList.find((tenant: any) => tenant.id === fId);
            const originAddress = matchedTenant.fullAddress;
            const destinationAddress = addressObj.address.destination;
            this.calculateDistanceByAddress(originAddress, destinationAddress, address).then((response) => {
                if (!response) {
                    const destination = addressObj.zipCode.destination ? addressObj.zipCode.destination.toString() : '';
                    this.calculateDistanceByZIP(matchedTenant.zipcode, destination, address);
                }
            });
        } else {
            const originAddress = addressObj.address.origin;
            const destinationAddress = addressObj.address.destination;
            this.calculateDistanceByAddress(originAddress, destinationAddress, address).then((response) => {
                if (!response) {
                    const destination = addressObj.zipCode.destination ? addressObj.zipCode.destination.toString() : '';
                    this.calculateDistanceByZIP(addressObj.zipCode.origin.toString(), destination, address);
                }
            });
        }
    }

    onChangeFrom(searchString?: string, isRemove?: boolean) {
        if (!searchString || searchString.length > 2) {
            this.fromModelChanged.next({ searchText: searchString, addressRemove: isRemove });
        }
    }

    onChangeTo(searchString?: string) {
        if (!searchString || searchString.length > 2) {
            this.toModelChanged.next({ searchText: searchString });
        }
    }

    onChangePayer(searchString?: string, isRemove?: boolean) {
        if (!searchString || searchString.length > 2) {
            this.payerModelChanged.next({ searchText: searchString, addressRemove: isRemove });
        }
    }

    onChangeIntermediary(searchString?: string) {
        if (!searchString || searchString.length > 2) {
            this.intermediaryModelChanged.next({ searchText: searchString });
        }
    }

    onChangeFromAddress(searchText?: string, isRemove?: boolean): void {
        if (!this.ordersFrom.addressId) {
            const request = {
                accountId: isRemove ? null : this.accountId,
                contactId: isRemove ? null : this.selectedContactId,
                searchQuery: searchText ? searchText : ''
            };
            this.isShipFromAddressLoading = true;
            this.contactService.getAddressDetailsList(request).subscribe(response => {
                this.isShipFromAddressLoading = false;
                this.addressFromList = response.data;
                if (this.accountParamLocal.isParticipantsConfigure) {
                    if (!this.accountParamLocal.isUpdateFromAccountDetails && this.accountParamLocal.contactId) {
                        const addressFromListPrimary = response.data.find(item => this.accountId === item.accountId
                            && item.isPrimaryContact);
                        let addressFromListSelected = response.data.find(item => this.accountParamLocal.contactId === item.contactId);
                        this.selectedContactAccountId = addressFromListSelected ? addressFromListSelected.accountId : this.selectedContactAccountId;
                        if (this.selectedContactId && this.isContactChanged) {
                            addressFromListSelected = response.data.find(item => item.contactId === this.selectedContactId);
                            this.selectedContactAccountId = addressFromListSelected ? addressFromListSelected.accountId : this.selectedContactAccountId;
                        }
                        if ((!this.shipper && this.initialLoadFrom && this.addressFromList && this.addressFromList.length > 0) && addressFromListSelected) {
                            this.commonService.objectMapping(this.ordersFrom, addressFromListSelected);
                            this.primaryContactId = addressFromListPrimary.contactId;
                            this.emitShippingInfoFrom.emit(this.ordersFrom);
                            this.initialLoadFrom = false;
                        }
                        this.ordersFromAddressCalculation();
                    } else {
                        if (this.addressFromList.find(item => this.ordersTo.accountId === item.accountId
                            && this.ordersTo.addressId === item.addressId && this.ordersTo.contactId === item.contactId)) {
                            this.commonService.objectMapping(this.ordersTo,
                                this.addressFromList.find(item => this.ordersTo.accountId === item.accountId
                                    && this.ordersTo.addressId === item.addressId && this.ordersTo.contactId === item.contactId));
                        }
                        this.getTenantByZip(this.ordersTo.zipCode);
                        if (this.addressFromList.find(item => this.ordersPayer.accountId === item.accountId
                            && this.ordersPayer.addressId === item.addressId && this.ordersPayer.contactId === item.contactId)) {
                            this.commonService.objectMapping(this.ordersPayer,
                                this.addressFromList.find(item => this.ordersPayer.accountId === item.accountId
                                    && this.ordersPayer.addressId === item.addressId && this.ordersPayer.contactId === item.contactId));
                        }
                        if (this.addressFromList.find(item => this.ordersIntermediary.accountId === item.accountId
                            && this.ordersIntermediary.addressId === item.addressId
                            && this.ordersIntermediary.contactId === item.contactId)) {
                            this.commonService.objectMapping(this.ordersIntermediary,
                                this.addressFromList.find(item => this.ordersIntermediary.accountId === item.accountId
                                    && this.ordersIntermediary.addressId === item.addressId
                                    && this.ordersIntermediary.contactId === item.contactId));
                        }
                        this.emitRevertUpdateAccountDetails.emit(true);
                    }

                    if (this.ordersFrom.addressId === this.ordersTo.addressId && this.ordersFrom.contactId === this.ordersTo.contactId) {
                        this.commonService.objectMapping(this.ordersTo, this.ordersFrom);
                        this.ordersTo.isChanged = true;
                        this.ordersTo.isConsigneeAddress = this.consignee ? this.consignee.isConsigneeAddress : false;
                        this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
                    }
                    this.getTenantByZip(this.ordersTo.zipCode);
                    if (this.ordersFrom.addressId === this.ordersPayer.addressId && this.ordersFrom.contactId === this.ordersPayer.contactId) {
                        this.commonService.objectMapping(this.ordersPayer, this.ordersFrom);
                    }
                    if (this.ordersFrom.addressId === this.ordersIntermediary.addressId && this.ordersFrom.contactId === this.ordersIntermediary.contactId) {
                        this.commonService.objectMapping(this.ordersIntermediary, this.ordersFrom);
                        this.ordersIntermediary.isConsigneeAddress = this.intermediary ? this.intermediary.isConsigneeAddress : false;
                        this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
                    }
                }
            });
        } else {
            if (this.selectedContactId === null) {
                if (this.isContactChanged && this.selectedContactAccountId === this.ordersFrom.accountId) {
                    this.onRemoveFromAddress();
                }
            }
            if (this.ordersFrom.addressId && this.selectedContactId) {
                this.isShipFromAddressLoading = true;
                const request = {
                    accountId: this.accountId,
                    contactId: this.selectedContactId,
                    searchQuery: searchText ? searchText : ''
                };
                this.contactService.getAddressDetailsList(request).subscribe(response => {
                    this.isShipFromAddressLoading = false;
                    this.addressFromList = response.data;
                    const addressFromListPrimary = this.addressFromList.find(item => item.contactId === this.selectedContactId);
                    this.selectedContactAccountId = addressFromListPrimary ? addressFromListPrimary.accountId : this.selectedContactAccountId;
                    if (addressFromListPrimary && this.ordersFrom.accountId === addressFromListPrimary.accountId) {
                        this.commonService.objectMapping(this.ordersFrom, addressFromListPrimary);
                        this.ordersFromAddressCalculation();
                    }

                    if (this.ordersFrom.addressId === this.ordersTo.addressId && this.ordersFrom.contactId === this.ordersTo.contactId) {
                        this.commonService.objectMapping(this.ordersTo, this.ordersFrom);
                        this.ordersTo.isConsigneeAddress = this.consignee ? this.consignee.isConsigneeAddress : false;
                        this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
                    }
                    this.getTenantByZip(this.ordersTo.zipCode);
                    if (this.ordersFrom.addressId === this.ordersPayer.addressId && this.ordersFrom.contactId === this.ordersPayer.contactId) {
                        this.commonService.objectMapping(this.ordersPayer, this.ordersFrom);
                    }
                    if (this.ordersFrom.addressId === this.ordersIntermediary.addressId && this.ordersFrom.contactId === this.ordersIntermediary.contactId) {
                        this.commonService.objectMapping(this.ordersIntermediary, this.ordersFrom);
                        this.ordersIntermediary.isConsigneeAddress = this.intermediary ? this.intermediary.isConsigneeAddress : false;
                        this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
                    }
                });
            }
        }
    }

    ordersFromAddressCalculation() {
        const address = {
            zipCode: {
                origin: this.getTZipcode,
                destination: this.ordersFrom.zipCode
            },
            address: {
                origin: this.getTFullAddress,
                destination: `${this.ordersFrom.addressLine1 ? this.ordersFrom.addressLine1 : ''}, ${this.ordersFrom.addressLine2 ? this.ordersFrom.addressLine2 : ''}, ${this.ordersFrom.city ? this.ordersFrom.city : ''}, ${this.ordersFrom.zipCode ? this.ordersFrom.zipCode : ''}, ${this.ordersFrom.countryName ? this.ordersFrom.countryName : ''}`
            }
        };
        setTimeout(() => { this.calculateDistance(address, this.ordersFrom); }, 500);
        this.setTenantByZip(this.ordersFrom.zipCode, this.ordersFrom);
        this.initialLoadFrom = false;
    }

    onChangeToAddress(searchText?: string): void {
        if (!this.ordersTo.addressId) {
            this.addressToList = [];
            const request = {
                accountId: null,
                searchQuery: searchText ? searchText : ''
            };
            this.isShipToAddressLoading = true;
            this.contactService.getAddressDetailsList(request).subscribe(response => {
                this.isShipToAddressLoading = false;
                this.addressToList = response.data;
            });
        }
    }

    onChangePayerAddress(searchText?: string, isRemove?: boolean): void {
        if (!this.ordersPayer.addressId) {
            const request = {
                accountId: isRemove ? null : this.accountId,
                contactId: isRemove ? null : this.selectedContactId,
                searchQuery: searchText ? searchText : ''
            };
            this.isPayerAddressLoading = true;
            this.contactService.getAddressDetailsList(request).subscribe(response => {
                this.isPayerAddressLoading = false;
                this.addressPayerList = response.data;
                const peimaryContactDetails = response.data.find(item => this.accountId === item.accountId && item.isPrimaryContact);
                if (this.accountParamLocal.isParticipantsConfigure) {
                    if (!this.payer && this.initialLoadPayer && this.addressPayerList && this.addressPayerList.length > 0) {
                        if (!this.primaryContactId) {
                            this.primaryContactId = peimaryContactDetails.contactId;
                        }
                        while (this.primaryContactId && this.initialLoadPayer) {
                            let addressPayerListPrimary;
                            if (this.primaryContactId && this.initialLoadPayer) {
                                addressPayerListPrimary = response.data.find(item => this.accountId === item.accountId && item.isPrimaryContact);
                            }
                            const accountContacts = this.addressPayerList.find(accCont => accCont.accountId === this.accountId);
                            if (accountContacts && addressPayerListPrimary) {
                                this.commonService.objectMapping(this.ordersPayer, addressPayerListPrimary);
                            }
                            this.initialLoadPayer = false;
                        }

                    }
                }
                if (this.ordersPayer.addressId === this.ordersFrom.addressId && this.ordersPayer.contactId === this.ordersFrom.contactId) {
                    this.commonService.objectMapping(this.ordersFrom, this.ordersPayer);
                }
                if (this.ordersPayer.addressId === this.ordersTo.addressId && this.ordersPayer.contactId === this.ordersTo.contactId) {
                    this.commonService.objectMapping(this.ordersTo, this.ordersPayer);
                    this.ordersTo.isConsigneeAddress = this.consignee ? this.consignee.isConsigneeAddress : false;
                    this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
                }
                if (this.ordersPayer.addressId === this.ordersIntermediary.addressId && this.ordersPayer.contactId === this.ordersIntermediary.contactId) {
                    this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer);
                    this.ordersIntermediary.isConsigneeAddress = this.intermediary ? this.intermediary.isConsigneeAddress : false;
                    this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
                }
            });
        }
    }

    onChangeIntermediaryAddress(searchText?: string): void {
        if (!this.ordersIntermediary.addressId) {
            const request = {
                accountId: null,
                searchQuery: searchText ? searchText : ''
            };
            this.isIntermediaryAddressLoading = true;
            this.contactService.getAddressDetailsList(request).subscribe(response => {
                this.isIntermediaryAddressLoading = false;
                this.addressIntermediaryList = response.data;
            });
        }
    }

    onBindAddress(item: any) {
        return item
            ? `${item.addressLine1 || ''}${item.addressLine2 ? `, ${item.addressLine2}` : ''}${item.city ? `, ${item.city}` : ''} ${item.provinceName || ''} ${item.zipCode || ''} ${item.countryName || ''}`.trim()
            : '';
    }

    onSetFromAddress(event: any, address: any): any {
        if (address && address.contactId) {
            this.commonService.objectMapping(this.ordersFrom, address);
            if (this.shipper && this.shipper.shippingInfoId) {
                this.ordersFrom.shippingInfoId = this.shipper.shippingInfoId;
            }
            this.ordersFrom.isChanged = true;
            this.isFromCustomAddress = address.isQuickContact;
            const addressObj = {
                zipCode: {
                    origin: this.getTZipcode,
                    destination: address.zipCode
                },
                address: {
                    origin: this.getTFullAddress,
                    destination: `${address.addressLine1 ? address.addressLine1 : ''}, ${address.addressLine2 ? address.addressLine2 : ''}, ${address.city ? address.city : ''}, ${address.zipCode ? address.zipCode : ''}, ${address.countryName ? address.countryName : ''}`
                }
            };
            this.calculateDistance(addressObj, this.ordersFrom);
            this.setTenantByZip(address.zipCode, this.ordersFrom);
            this.emitShippingInfoFrom.emit(this.ordersFrom);
        } else {
            this.toastr.warning(CommonConstants.contactListConstants.contactNotAssociated);
        }
    }

    setTenantByZip(zip: any, address: any) {
        const searchQuery = `Zipcode=${zip}`;
        this.commonService.getTenantByZip(searchQuery).subscribe(response => {
            if (response.isSuccess) {
                address.ownedByTenant = response.data.name;
            }
        });
    }

    onSetToAddress(address: any): void {
        if (address && address.contactId) {
            this.commonService.objectMapping(this.ordersTo, address);
            if (this.consignee && this.consignee.shippingInfoId) {
                this.ordersTo.shippingInfoId = this.consignee.shippingInfoId;
                this.ordersTo.isConsigneeAddress = this.consignee.isConsigneeAddress;
                this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
            } else {
                this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
                this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
            }
            this.ordersTo.isChanged = true;
            this.isToCustomAddress = address.isQuickContact;
            this.getTenantByZip(this.ordersTo.zipCode);
            this.emitShippingInfoTo.emit(this.ordersTo);
        } else {
            this.toastr.warning(CommonConstants.contactListConstants.contactNotAssociated);
        }
    }

    onSetPayerAddress(event: any, address: any): any {
        if (address && address.contactId) {
            this.commonService.objectMapping(this.ordersPayer, address);
            if (this.payer && this.payer.shippingInfoId) {
                this.ordersPayer.shippingInfoId = this.payer.shippingInfoId;
            }
            this.ordersPayer.isChanged = true;
            this.isPayerCustomAddress = address.isQuickContact;
        } else {
            this.toastr.warning(CommonConstants.contactListConstants.contactNotAssociated);
        }
    }

    onSetIntermediaryAddress(address: any): any {
        if (address && address.contactId) {
            this.commonService.objectMapping(this.ordersIntermediary, address);
            if (this.intermediary && this.intermediary.shippingInfoId) {
                this.ordersIntermediary.shippingInfoId = this.intermediary.shippingInfoId;
                this.ordersIntermediary.isConsigneeAddress = this.intermediary.isConsigneeAddress;
                this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
            } else {
                this.ordersIntermediary.isConsigneeAddress = this.ordersTo.accountId == null ? false : this.ordersTo.isConsigneeAddress ? false : true;
                this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
            }
            this.ordersIntermediary.isChanged = true;
            this.isIntermediaryCustomAddress = address.isQuickContact;
        } else {
            this.toastr.warning(CommonConstants.contactListConstants.contactNotAssociated);
        }
    }

    onSetToAddressAsFromAddress() {
        this.commonService.objectMapping(this.ordersTo, this.ordersFrom);
    }

    setShippingInformation() {
        this.commonService.objectMapping(this.ordersFrom, this.shipper);
        this.isFromCustomAddress = this.shipper.isQuickContact;
        this.commonService.objectMapping(this.ordersTo, this.consignee);
        this.isToCustomAddress = this.consignee.isQuickContact;
        if (this.payer) {
            this.commonService.objectMapping(this.ordersPayer, this.payer);
            this.isPayerCustomAddress = this.payer.isQuickContact;
        }
        if (this.intermediary) {
            this.commonService.objectMapping(this.ordersIntermediary, this.intermediary);
            this.isIntermediaryCustomAddress = this.intermediary.isQuickContact;
        }
    }

    onSetSameAsAddress(setDestinationAddress: any, originAddress: any, originShippingType: string, sourceId: number) {
        if (originAddress.contactId) {
            this.commonService.objectMapping(setDestinationAddress, originAddress);
            setDestinationAddress.isChanged = true;
            this.shippingAddressForm.form.markAsDirty();
            if (sourceId === this.shippingContactTypeNameEnum.shipper) {
                this.isFromCustomAddress = setDestinationAddress.isQuickContact;
                setDestinationAddress.shippingInfoId = this.shipper ? this.shipper.shippingInfoId : null;
                const address = {
                    zipCode: {
                        origin: this.getTZipcode,
                        destination: setDestinationAddress.zipCode
                    },
                    address: {
                        origin: this.getTFullAddress,
                        destination: `${setDestinationAddress.addressLine1 ? setDestinationAddress.addressLine1 : ''}, ${setDestinationAddress.addressLine2 ? setDestinationAddress.addressLine2 : ''}, ${setDestinationAddress.city ? setDestinationAddress.city : ''}, ${setDestinationAddress.provinceName ? setDestinationAddress.provinceName : ''}, ${setDestinationAddress.zipCode ? setDestinationAddress.zipCode : ''}, ${setDestinationAddress.countryName ? setDestinationAddress.countryName : ''}`
                    }
                };
                this.calculateDistance(address, setDestinationAddress);
                this.setTenantByZip(setDestinationAddress.zipCode, setDestinationAddress);
                this.emitShippingInfoFrom.emit(setDestinationAddress);
            }
            if (sourceId === this.shippingContactTypeNameEnum.consignee) {
                this.isToCustomAddress = setDestinationAddress.isQuickContact;
                setDestinationAddress.shippingInfoId = this.consignee ? this.consignee.shippingInfoId : null;
                this.getTenantByZip(setDestinationAddress.zipCode);
                this.emitShippingInfoTo.emit(setDestinationAddress);
                this.ordersTo.isConsigneeAddress = this.consignee ? this.consignee.isConsigneeAddress : this.ordersIntermediary.isConsigneeAddress ? false : true;
                this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
            }
            if (sourceId === this.shippingContactTypeNameEnum.payer) {
                this.isPayerCustomAddress = setDestinationAddress.isQuickContact;
                setDestinationAddress.shippingInfoId = this.payer ? this.payer.shippingInfoId : null;
            }
            if (sourceId === this.shippingContactTypeNameEnum.intermediary) {
                this.isIntermediaryCustomAddress = setDestinationAddress.isQuickContact;
                setDestinationAddress.shippingInfoId = this.intermediary ? this.intermediary.shippingInfoId : null;
                this.ordersIntermediary.isConsigneeAddress = this.intermediary ? this.intermediary.isConsigneeAddress : this.ordersTo.accountId == null ? false : this.ordersTo.isConsigneeAddress ? false : true;
                this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
            }
        } else {
            this.toastr.error(`Please Select ${originShippingType} Address.`);
        }
    }

    onRemoveFromAddress() {
        this.commonService.getConfirmationPopup(CommonConstants.contactListConstants.removeFromAddressConfirmation).then(result => {
            if (result) {
                this.ordersFrom = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.onChangeFromAddress('', true);
                this.isFromCustomAddress = false;
                this.shippingAddressForm.form.markAsDirty();
                this.emitShippingInfoFrom.emit(this.ordersFrom);
                this.shipToFranchiseDetails = Object.assign({});
            }
        });
    }

    onRemoveToAddress() {
        this.commonService.getConfirmationPopup(CommonConstants.contactListConstants.removeToAddressConfirmation).then(result => {
            if (result) {
                this.ordersTo.addressId = null;
                this.onChangeToAddress();
                this.ordersTo = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.isToCustomAddress = false;
                this.shippingAddressForm.form.markAsDirty();
                this.emitShippingInfoTo.emit(this.ordersTo);
                this.shipToFranchiseDetails = Object.assign({}, null);
            }
        });
    }

    onRemovePayerAddress() {
        this.commonService.getConfirmationPopup(CommonConstants.contactListConstants.removeBillToAddressConfirmation).then(result => {
            if (result) {
                this.ordersPayer.addressId = null;
                this.onChangePayerAddress('', true);
                this.ordersPayer = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.shippingAddressForm.form.markAsDirty();
                this.isPayerCustomAddress = false;
            }
        });
    }

    onRemoveIntermediaryAddress() {
        this.commonService.getConfirmationPopup(CommonConstants.contactListConstants.removeIntermediaryAddressConfirmation).then(result => {
            if (result) {
                this.ordersIntermediary.addressId = null;
                this.onChangeIntermediaryAddress();
                if (this.ordersIntermediary.isConsigneeAddress) {
                    this.onIsConsigneeAddressChange('');
                }
                this.ordersIntermediary = Object.assign({}, this.ordersDataModel.shippingAddressModel);
                this.shippingAddressForm.form.markAsDirty();
                this.isIntermediaryCustomAddress = false;
            }
        });
    }

    onAddCustomAddress(data: any) {
        this.shippingAddressForm.form.markAsDirty();
        switch (data.shippingType) {
            case 1:
                this.ordersFrom.addressLine1 = null;
                this.ordersFrom.addressLine2 = null;
                this.ordersFrom.addressId = null;
                this.commonService.objectMapping(this.ordersFrom, data);
                this.ordersFrom.accountName = data.accountName;
                if (data.name) {
                    this.ordersFrom.contactName = data.name;
                }
                this.ordersFrom.phoneNumber = data.phone ? data.phone : null;
                this.isFromCustomAddress = data.isQuickContact;
                if (this.shipper && this.shipper.shippingInfoId) {
                    data.shippingInfoId = this.shipper.shippingInfoId;
                    this.ordersFrom.shippingInfoId = this.shipper.shippingInfoId;
                }
                this.ordersFrom.isChanged = true;
                const address = {
                    zipCode: {
                        origin: this.getTZipcode,
                        destination: this.ordersFrom.zipCode
                    },
                    address: {
                        origin: this.getTFullAddress,
                        destination: `${this.ordersFrom.addressLine1 ? this.ordersFrom.addressLine1 : ''}, ${this.ordersFrom.addressLine2 ? this.ordersFrom.addressLine2 : ''}, ${this.ordersFrom.city ? this.ordersFrom.city : ''}, ${this.ordersFrom.provinceName ? this.ordersFrom.provinceName : ''}, ${this.ordersFrom.zipCode ? this.ordersFrom.zipCode : ''}, ${this.ordersFrom.countryName ? this.ordersFrom.countryName : ''}`
                    }
                };
                this.calculateDistance(address, this.ordersFrom);
                this.setTenantByZip(data.zipCode, this.ordersFrom);
                this.emitShippingInfoFrom.emit(data);
                break;
            case 2:
                this.ordersTo.addressId = null;
                this.ordersTo.addressLine1 = null;
                this.ordersTo.addressLine2 = null;
                this.commonService.objectMapping(this.ordersTo, data);
                this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
                this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
                this.ordersTo.accountName = data.accountName;
                if (data.name) {
                    this.ordersTo.contactName = data.name;
                }
                this.ordersTo.phoneNumber = data.phone ? data.phone : null;
                this.isToCustomAddress = data.isQuickContact;
                if (this.consignee && this.consignee.shippingInfoId) {
                    data.shippingInfoId = this.consignee.shippingInfoId;
                    this.ordersTo.shippingInfoId = this.consignee.shippingInfoId;
                }
                this.ordersTo.isChanged = true;
                this.getTenantByZip(this.ordersTo.zipCode);
                this.emitShippingInfoTo.emit(data);
                break;
            case 3:
                this.ordersPayer.addressId = null;
                this.ordersPayer.addressLine1 = null;
                this.ordersPayer.addressLine2 = null;
                this.commonService.objectMapping(this.ordersPayer, data);
                this.ordersPayer.accountName = data.accountName;
                if (data.name) {
                    this.ordersPayer.contactName = data.name;
                }
                this.ordersPayer.phoneNumber = data.phone ? data.phone : null;
                if (this.payer && this.payer.shippingInfoId) {
                    this.ordersPayer.shippingInfoId = this.payer.shippingInfoId;
                }
                this.ordersPayer.isChanged = true;
                this.isPayerCustomAddress = data.isQuickContact;
                break;
            case 4:
                this.ordersIntermediary.addressId = null;
                this.ordersIntermediary.addressLine1 = null;
                this.ordersIntermediary.addressLine2 = null;
                this.commonService.objectMapping(this.ordersIntermediary, data);
                this.ordersTo.isConsigneeAddress = this.ordersIntermediary.isConsigneeAddress ? false : true;
                this.ordersIntermediary.isConsigneeAddress = this.ordersTo.accountId == null ? false : this.ordersTo.isConsigneeAddress ? false : true;
                this.ordersIntermediary.accountName = data.accountName;
                if (data.name) {
                    this.ordersIntermediary.contactName = data.name;
                }
                this.ordersIntermediary.phoneNumber = data.phone ? data.phone : null;
                this.isIntermediaryCustomAddress = data.isQuickContact;
                if (this.intermediary && this.intermediary.shippingInfoId) {
                    this.ordersIntermediary.shippingInfoId = this.intermediary.shippingInfoId;
                }
                this.ordersIntermediary.isChanged = true;
                break;
        }
    }

    onAddNewAddress() {
        this.dialog
            .open(AddAddressComponent, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                data: {
                    accountId: this.accountId ? this.accountId : null,
                    accountTypeId: this.accountTypeId ? this.accountTypeId : null
                },
                autoFocus: false
            }).afterClosed()
            .subscribe((response: any) => {
                if (response) {
                    this.commonService.objectMapping(this.ordersFrom, response);
                    this.isFromCustomAddress = true;
                    this.emitShippingInfoFrom.emit(response);
                }
            });
    }

    autoCompleteScrollEvent = (event: any): void => {
        if (event.target && event.target.className && event.target.className.indexOf('mat-autocomplete-visible') === -1) {
            if (this.shipFromAutoComplete && this.shipFromAutoComplete.panelOpen) {
                this.shipFromAutoComplete.closePanel();
            } else if (this.shipToAutoComplete && this.shipToAutoComplete.panelOpen) {
                this.shipToAutoComplete.closePanel();
            } else if (this.shipPayerAutoComplete && this.shipPayerAutoComplete.panelOpen) {
                this.shipPayerAutoComplete.closePanel();
            } else if (this.shipIntermediaryAutoComplete && this.shipIntermediaryAutoComplete.panelOpen) {
                this.shipIntermediaryAutoComplete.closePanel();
            }
        }
    }

    onOpenShipFromOption() {
        this.shipFromAutoComplete.openPanel();
    }

    onOpenShipToOption() {
        this.shipToAutoComplete.openPanel();
    }

    onOpenShipPayerOption() {
        this.shipPayerAutoComplete.openPanel();
    }

    onOpenShipIntermediaryOption() {
        this.shipIntermediaryAutoComplete.openPanel();
    }

    onChangeAddressForCarrierShipment(address: any) {
        address.isChanged = true;
        this.emitShippingInfoFrom.emit(address);
    }

    onEditQuickAccount(shippingInfoType: any) {
        let contactId;
        switch (shippingInfoType) {
            case this.shippingContactTypeNameEnum.intermediary:
                contactId = this.ordersIntermediary.contactId;
                break;
            case this.shippingContactTypeNameEnum.payer:
                contactId = this.ordersPayer.contactId;
                break;
            case this.shippingContactTypeNameEnum.shipper:
                contactId = this.ordersFrom.contactId;
                break;
            case this.shippingContactTypeNameEnum.consignee:
                contactId = this.ordersTo.contactId;
                break;
        }

        this.dialog
            .open(AddQuickContactComponentForm, {
                position: {
                    right: '0',
                },
                panelClass: 'small_layout',
                hasBackdrop: false,
                autoFocus: false,
                // if quick Account pass true else false
                data: { contactId, orderId: this.order_Id }
            }).afterClosed()
            .subscribe((response: any) => {
                if (response !== false) {
                    const previouseShipFromZipCode = this.ordersFrom.zipCode;
                    this.shippingAddressForm.form.markAsDirty();
                    switch (shippingInfoType) {
                        case this.shippingContactTypeNameEnum.intermediary:
                            this.commonService.objectMapping(this.ordersIntermediary, response);
                            this.ordersIntermediary.isQuickContact = response.isConvertToLead ? false : this.ordersIntermediary.isQuickContact;
                            this.isIntermediaryCustomAddress = this.ordersIntermediary.isQuickContact;
                            this.ordersIntermediary.provinceName = response.province || '';
                            this.ordersIntermediary.isChanged = true;
                            this.ordersIntermediary.primaryExt = response.ext;
                            this.ordersIntermediary.contactName =
                                (response.firstName ? response.firstName + ' ' : '') + (response.lastName ? response.lastName : '');
                            this.ordersIntermediary.phoneNumber = response.phone;
                            if (this.ordersFrom.contactId === this.ordersIntermediary.contactId) {
                                this.isFromCustomAddress = this.ordersIntermediary.isQuickContact;
                                this.commonService.objectMapping(this.ordersFrom, this.ordersIntermediary);
                            }
                            if (this.ordersTo.contactId === this.ordersIntermediary.contactId) {
                                this.isToCustomAddress = this.ordersIntermediary.isQuickContact;
                                this.commonService.objectMapping(this.ordersTo, this.ordersIntermediary);
                            }
                            if (this.ordersPayer.contactId === this.ordersIntermediary.contactId) {
                                this.isPayerCustomAddress = this.ordersIntermediary.isQuickContact;
                                this.commonService.objectMapping(this.ordersPayer, this.ordersIntermediary);
                            }
                            break;
                        case this.shippingContactTypeNameEnum.payer:
                            this.commonService.objectMapping(this.ordersPayer, response);
                            this.ordersPayer.isQuickContact = response.isConvertToLead ? false : this.ordersPayer.isQuickContact;
                            this.isPayerCustomAddress = this.ordersPayer.isQuickContact;
                            this.ordersPayer.provinceName = response.province || '';
                            this.ordersPayer.isChanged = true;
                            this.ordersPayer.primaryExt = response.ext;
                            this.ordersPayer.contactName =
                                (response.firstName ? response.firstName + ' ' : '') + (response.lastName ? response.lastName : '');
                            this.ordersPayer.phoneNumber = response.phone;
                            this.ordersIntermediary.isQuickContact ? this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer) : '';
                            if (this.ordersFrom.contactId === this.ordersPayer.contactId) {
                                this.isFromCustomAddress = this.ordersPayer.isQuickContact;
                                this.commonService.objectMapping(this.ordersFrom, this.ordersPayer);
                            }
                            if (this.ordersTo.contactId === this.ordersPayer.contactId) {
                                this.isToCustomAddress = this.ordersPayer.isQuickContact;
                                this.commonService.objectMapping(this.ordersTo, this.ordersPayer);
                            }
                            if (this.ordersIntermediary.contactId === this.ordersPayer.contactId) {
                                this.isPayerCustomAddress = this.ordersPayer.isQuickContact;
                                this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer);
                            }
                            break;
                        case this.shippingContactTypeNameEnum.shipper:
                            this.commonService.objectMapping(this.ordersFrom, response);
                            this.ordersFrom.isQuickContact = response.isConvertToLead ? false : this.ordersFrom.isQuickContact;
                            this.isFromCustomAddress = this.ordersFrom.isQuickContact;
                            this.ordersFrom.provinceName = response.province || '';
                            this.ordersFrom.isChanged = true;
                            this.ordersFrom.primaryExt = response.ext;
                            this.ordersFrom.contactName =
                                (response.firstName ? response.firstName + ' ' : '') + (response.lastName ? response.lastName : '');
                            this.ordersFrom.phoneNumber = response.phone;
                            if (this.ordersTo.contactId === this.ordersFrom.contactId) {
                                this.isToCustomAddress = this.ordersFrom.isQuickContact;
                                this.commonService.objectMapping(this.ordersTo, this.ordersFrom);
                            }
                            if (this.ordersPayer.contactId === this.ordersFrom.contactId) {
                                this.isPayerCustomAddress = this.ordersFrom.isQuickContact;
                                this.commonService.objectMapping(this.ordersPayer, this.ordersFrom);
                            }
                            if (this.ordersIntermediary.contactId === this.ordersFrom.contactId) {
                                this.isIntermediaryCustomAddress = this.ordersFrom.isQuickContact;
                                this.commonService.objectMapping(this.ordersIntermediary, this.ordersFrom);
                            }
                            break;
                        case this.shippingContactTypeNameEnum.consignee:
                            this.commonService.objectMapping(this.ordersTo, response);
                            this.ordersTo.isQuickContact = response.isConvertToLead ? false : this.ordersTo.isQuickContact;
                            this.isToCustomAddress = this.ordersTo.isQuickContact;
                            this.ordersTo.provinceName = response.province || '';
                            this.ordersTo.isChanged = true;
                            this.ordersTo.primaryExt = response.ext;
                            this.ordersTo.contactName =
                                (response.firstName ? response.firstName + ' ' : '') + (response.lastName ? response.lastName : '');
                            this.ordersTo.phoneNumber = response.phone;
                            if (this.ordersFrom.contactId === this.ordersTo.contactId) {
                                this.isFromCustomAddress = this.ordersTo.isQuickContact;
                                this.commonService.objectMapping(this.ordersFrom, this.ordersTo);
                            }
                            if (this.ordersPayer.contactId === this.ordersTo.contactId) {
                                this.isPayerCustomAddress = this.ordersTo.isQuickContact;
                                this.commonService.objectMapping(this.ordersPayer, this.ordersTo);
                            }
                            if (this.ordersIntermediary.contactId === this.ordersTo.contactId) {
                                this.isIntermediaryCustomAddress = this.ordersTo.isQuickContact;
                                this.commonService.objectMapping(this.ordersIntermediary, this.ordersTo);
                            }
                            break;
                    }
                    if (previouseShipFromZipCode !== response.zipCode && response.contactId === this.ordersFrom.contactId) {
                        const address = {
                            zipCode: {
                                origin: this.getTZipcode,
                                destination: response.zipCode
                            },
                            address: {
                                origin: this.getTFullAddress,
                                destination: `${response.addressLine1 ? response.addressLine1 : ''}, ${response.addressLine2 ? response.addressLine2 : ''}, ${response.city ? response.city : ''}, ${response.zipCode ? response.zipCode : ''}, ${response.countryName ? response.countryName : ''}`
                            }
                        };
                        this.calculateDistance(address, this.ordersFrom);
                    }
                }
            });
    }

    onOpenAccountDetails(address: any, shippingInfoType: number): void {
        if (address.accountTypeId === 2) {
            this.dialog
                .open(CustomerDetailsPopupComponent, {
                    position: {
                        top: '60px',
                        left: '60px'
                    },
                    height: '92%',
                    panelClass: ['small_layout', 'details_layout'],
                    hasBackdrop: false,
                    autoFocus: false,
                    data: { customerId: address.accountId }
                }).afterClosed()
                .subscribe((response: any) => {
                    if (response.success) {
                        this.updateShippingInfoDetails(response.data, address, shippingInfoType);
                    }
                });
        } else {
            this.dialog
                .open(LeadAccountDetailsPopupComponent, {
                    position: {
                        top: '60px',
                        left: '60px'
                    },
                    height: '92%',
                    panelClass: ['small_layout', 'details_layout'],
                    hasBackdrop: false,
                    autoFocus: false,
                    data: { leadId: address.accountId }
                }).afterClosed()
                .subscribe((response: any) => {
                    if (response.success) {
                        this.updateShippingInfoDetails(response.data, address, shippingInfoType);
                    }
                });
        }
    }

    updateShippingInfoDetails(response: any, address: any, shippingInfoType: number): void {
        this.shippingAddressForm.form.markAsDirty();
        const previouseShipFromZipCode = this.ordersFrom.zipCode;
        switch (shippingInfoType) {
            case this.shippingContactTypeNameEnum.intermediary:
                this.commonService.objectMapping(this.ordersIntermediary, response);
                this.ordersIntermediary.provinceName = response.contactLinkedAddress.provinceName || '';
                this.ordersIntermediary.isChanged = true;
                this.ordersIntermediary.primaryExt = response.primaryExtension;
                if (this.ordersIntermediary.contactId === response.contactId) {
                    this.mapAddresses(response, this.ordersIntermediary);
                }
                if (this.ordersFrom.contactId === this.ordersIntermediary.contactId) {
                    this.commonService.objectMapping(this.ordersFrom, this.ordersIntermediary);

                    if (this.ordersFrom.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersFrom);
                    }
                }
                if (this.ordersTo.contactId === this.ordersIntermediary.contactId) {
                    this.commonService.objectMapping(this.ordersTo, this.ordersIntermediary);

                    if (this.ordersTo.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersTo);
                    }
                }
                if (this.ordersPayer.contactId === this.ordersIntermediary.contactId) {
                    this.commonService.objectMapping(this.ordersPayer, this.ordersIntermediary);

                    if (this.ordersPayer.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersPayer);
                    }
                }
                break;
            case this.shippingContactTypeNameEnum.payer:
                this.commonService.objectMapping(this.ordersPayer, response);
                this.ordersPayer.provinceName = response.contactLinkedAddress.provinceName || '';
                this.ordersPayer.isChanged = true;
                this.ordersPayer.primaryExt = response.primaryExtension;
                if (this.ordersPayer.contactId === response.contactId) {
                    this.mapAddresses(response, this.ordersPayer);
                }
                this.ordersIntermediary.isQuickContact && this.ordersIntermediary.contactId === this.ordersPayer.contactId ? this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer) : '';
                if (this.ordersFrom.contactId === this.ordersPayer.contactId) {
                    this.commonService.objectMapping(this.ordersFrom, this.ordersPayer);

                    if (this.ordersFrom.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersFrom);
                    }
                }
                if (this.ordersTo.contactId === this.ordersPayer.contactId) {
                    this.commonService.objectMapping(this.ordersTo, this.ordersPayer);

                    if (this.ordersTo.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersTo);
                    }
                }
                if (this.ordersIntermediary.contactId === this.ordersPayer.contactId) {
                    this.commonService.objectMapping(this.ordersIntermediary, this.ordersPayer);

                    if (this.ordersIntermediary.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersIntermediary);
                    }
                }
                break;
            case this.shippingContactTypeNameEnum.shipper:
                this.commonService.objectMapping(this.ordersFrom, response);
                this.ordersFrom.provinceName = response.contactLinkedAddress.provinceName || '';
                this.ordersFrom.isChanged = true;
                this.ordersFrom.primaryExt = response.primaryExtension;
                if (this.ordersFrom.contactId === response.contactId) {
                    this.mapAddresses(response, this.ordersFrom);
                }
                if (this.ordersTo.contactId === this.ordersFrom.contactId) {
                    this.commonService.objectMapping(this.ordersTo, this.ordersFrom);

                    if (this.ordersTo.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersTo);
                    }
                }
                if (this.ordersPayer.contactId === this.ordersFrom.contactId) {
                    this.commonService.objectMapping(this.ordersPayer, this.ordersFrom);

                    if (this.ordersPayer.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersPayer);
                    }
                }
                if (this.ordersIntermediary.contactId === this.ordersFrom.contactId) {
                    this.commonService.objectMapping(this.ordersIntermediary, this.ordersFrom);

                    if (this.ordersIntermediary.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersIntermediary);
                    }
                }
                break;
            case this.shippingContactTypeNameEnum.consignee:
                this.commonService.objectMapping(this.ordersTo, response);
                this.ordersTo.provinceName = response.contactLinkedAddress.provinceName || '';
                this.ordersTo.isChanged = true;
                this.ordersTo.primaryExt = response.primaryExtension;
                if (this.ordersTo.contactId === response.contactId) {
                    this.mapAddresses(response, this.ordersTo);
                }
                if (this.ordersFrom.contactId === this.ordersTo.contactId) {
                    this.commonService.objectMapping(this.ordersFrom, this.ordersTo);

                    if (this.ordersFrom.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersFrom);
                    }
                }
                if (this.ordersPayer.contactId === this.ordersTo.contactId) {
                    this.commonService.objectMapping(this.ordersPayer, this.ordersTo);

                    if (this.ordersPayer.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersPayer);
                    }
                }
                if (this.ordersIntermediary.contactId === this.ordersTo.contactId) {
                    this.commonService.objectMapping(this.ordersIntermediary, this.ordersTo);

                    if (this.ordersIntermediary.contactId === response.contactId) {
                        this.mapAddresses(response, this.ordersIntermediary);
                    }
                }
                break;
        }
        this.ordersTo.isConsigneeAddress = this.consignee ? this.consignee.isConsigneeAddress : false;
        this.ordersIntermediary.isConsigneeAddress = this.ordersTo.isConsigneeAddress ? false : true;
        if (previouseShipFromZipCode !== response.primaryZipCode && response.contactId === this.ordersFrom.contactId) {
            const localAddress = {
                zipCode: {
                    origin: this.getTZipcode,
                    destination: response.associatedAccountAddress.zipCode
                },
                address: {
                    origin: this.getTFullAddress,
                    destination: `${response.associatedAccountAddress.addressLine1
                        ? response.associatedAccountAddress.addressLine1 + ', ' : ''}${response.associatedAccountAddress.addressLine2
                            ? response.associatedAccountAddress.addressLine2 + ', ' : ''}${response.associatedAccountAddress.city
                                ? response.associatedAccountAddress.city : ''}, ${response.associatedAccountAddress.zipCode
                                    ? response.associatedAccountAddress.zipCode : ''}, ${response.associatedAccountAddress.countryName
                                        ? response.associatedAccountAddress.countryName : ''}`
                }
            };
            setTimeout(() => { this.calculateDistance(localAddress, this.ordersFrom); }, 500);
            this.setTenantByZip(this.ordersFrom.zipCode, this.ordersFrom);
        }
        this.emitRevertUpdateAccountDetails.emit(false);
        this.emitUpdateAccountDetails.emit(response);

    }

    mapAddresses(fromAddress: any, toAddress: any): void {
        toAddress.contactName = fromAddress.contactName;
        toAddress.phoneNumber = fromAddress.primaryPhone;
        toAddress.email = fromAddress.email;
        toAddress.addressLine1 = fromAddress.contactLinkedAddress.addressLine1;
        toAddress.addressLine2 = fromAddress.contactLinkedAddress.addressLine2;
        toAddress.provinceName = fromAddress.contactLinkedAddress.provinceName;
        toAddress.zipCode = fromAddress.contactLinkedAddress.zipCode;
        toAddress.city = fromAddress.contactLinkedAddress.city;
    }

    getTenantByZip(zip: any) {
        const searchQuery = `Zipcode=${zip}`;
        this.commonService.getTenantByZip(searchQuery).subscribe(response => {
            if (response.isSuccess && response.data.zipcode) {
                this.shipToFranchiseDetails.isSpanToFranchiseDetails = true;
                this.shipToFranchiseDetails.txtSpanToFranchiseDetails = response.data.name + ', '
                    + response.data.city + ', '
                    + response.data.province + ', Ph: '
                    + response.data.phone + ', E-Mail: '
                    + response.data.email;
                this.shipToFranchiseDetails.franchise_general_email = response.data.email;
            } else if (response.isSuccess && response.data.code === CommonConstants.appComponent.corp) {
                this.shipToFranchiseDetails.isSpanToFranchiseDetails = true;
                this.shipToFranchiseDetails.txtSpanToFranchiseDetails = CommonConstants.appComponent.noFranchiseInformationAvailable;
                this.shipToFranchiseDetails.franchise_general_email = response.data.email;
            }
        });
    }

    onIsConsigneeAddressChange(address) {
        this.shippingAddressForm.form.markAsDirty();
        this.ordersTo.isChanged = true;
        this.ordersIntermediary.isChanged = true;
        if (address === 'ordersIntermediaryIsConsigneeAddress') {
            this.ordersTo.isConsigneeAddress = false;
            this.ordersIntermediary.isConsigneeAddress = true;
            if (this.consignee && this.intermediary) {
                this.consignee.isConsigneeAddress = false;
                this.intermediary.isConsigneeAddress = true;
            }
            this.emitShippingInfoTo.emit(this.ordersIntermediary);
        } else {
            this.ordersTo.isConsigneeAddress = true;
            this.ordersIntermediary.isConsigneeAddress = false;
            if (this.consignee && this.intermediary) {
                this.consignee.isConsigneeAddress = true;
                this.intermediary.isConsigneeAddress = false;
            }
            this.emitShippingInfoTo.emit(this.ordersTo);
        }
    }

    onOpenMapPopup(address) {
        this.isMapLoading = true;
        this.desti = `${address.addressLine1 ? address.addressLine1 + ',' : ''} ${address.addressLine2 ? address.addressLine2 + ',' : ''} ${address.city ? address.city + ',' : ''} ${address.zipCode ? address.zipCode + ',' : ''} ${address.countryName ? address.countryName : ''}`;
        const directionsService = new google.maps.DirectionsService();
        const request = {
            origin: this.getTFullAddress,
            destination: this.desti,
            travelMode: google.maps.TravelMode.DRIVING
        };
        directionsService.route(request, function (response, status) {
            if (status === google.maps.DirectionsStatus.OK && response.routes.length) {
                this.getMapPopup(CommonConstants.appComponent.no,
                    CommonConstants.appComponent.yes, false, true, response).then((result: any) => {
                    });
            } else {
                this.isMapLoading = false;
                this.toastr.error(CommonConstants.contactListConstants.unableToLoadRoutes);
            }
        }.bind(this));

    }

    getMapPopup(cancelLabel?: string, confirmLabel?: string, isHideCrossButton?: boolean,
        isAccountDropDownList?: boolean, directions?: any) {
        this.isMapLoading = false;
        return new Promise((resolve) => {
            this.dialog.open(MapDialogComponent, {
                panelClass: 'map-center-layout',
                hasBackdrop: false,
                data: {
                    cancelLabel: cancelLabel ? cancelLabel : CommonConstants.appComponent.no,
                    confirmLabel: confirmLabel ? confirmLabel : CommonConstants.appComponent.yes,
                    isShowCrossButton: isHideCrossButton ? false : true,
                    isShowAccountDropDownList: isAccountDropDownList ? true : false,
                    dir: directions
                },
            }).afterClosed()
                .subscribe((response: { confirmResult: boolean, accountInfo: any }) => {
                    resolve(response);
                });
        });
    }
}
